// generated by the plop

import { PaginateQuery, PaginatorModel, UnknownError } from 'symbols';
import {
  AsteriskEndpoint,
  CallLogModel,
  CONNECT_STATUS_WS,
  ContactModel, DongleStatusEnum,
  ExtensionStatusModel,
  GpCallMetaModel,
  InternalCallModel
} from '../../symbols';


export class ChangeConnectARI {
  static type = '[Asterisk] ChangeConnectARI';

  constructor(public payload: CONNECT_STATUS_WS) {
  }
}

export class CallingIn {
  static type = '[Asterisk] CallingIn';

  constructor(public payload: GpCallMetaModel) {
  }
}

export class UpdateCallState {
  static type = '[Asterisk] UpdateState';

  constructor(public payload: GpCallMetaModel) {
  }
}

// подія з WebSocket бекенду: стан внутрішнього дзвінка між співробітниками
export class InternalCallUpdate {
  static type = '[Asterisk] InternalCall';

  constructor(public payload: InternalCallModel) {
  }
}

export class RemoveCall {
  static type = '[Asterisk] RemoveCall';

  constructor(public payload: string) {
  }
}

export class GetChannels {
  static type = '[Asterisk] GetChannels';

  constructor(public callList: GpCallMetaModel[]) {
  }
}


export class SetVolume {
  static type = '[Asterisk] SetVolume';

  constructor(public value: number) {
  }
}

export class SetCountConnected {
  static type = '[Asterisk] SetCountConnected';

  constructor(public count: number) {
  }
}

export class ToCall {
  static type = '[Asterisk] ToCall';

  // endpoint — куди АТС дзвонить спершу (за замовчуванням SIP/<номер>; PJSIP/<номер> — вбудований телефон mobile)
  constructor(public tel: string, public endpoint?: string) {
  }
}

export class ToCallFail {
  static type = '[Asterisk] ToCallFail';

}

export class GetEndpoints {
  static type = '[Asterisk] GetEndpoints';

}

export class GetEndpointsSuccess {
  static type = '[Asterisk] GetEndpointsSuccess';

  constructor(public endpoints: AsteriskEndpoint[]) {
  }
}

export class GetEndpointsFail {
  static type = '[Asterisk] GetEndpointsFail';

  constructor(public error: UnknownError) {
  }
}

export class ExtensionStatus {
  static type = '[Asterisk] Extension Status';

  constructor(public payload: ExtensionStatusModel) {
  }
}


export class SetRoutine {
  static type = '[Asterisk] SetRoutine';

  constructor(public payload: boolean) {
  }
}


// added by plop
export class GetContacts {
  static type = '[gpAsterisk] GetContacts';

  constructor(public search?: string) {
  }
}


export class GetContactsSuccess {
  static type = '[gpAsterisk] GetContactsSuccess';

  constructor(public contacts: ContactModel[]) {
  }
}


export class GetContactsFail {
  static type = '[gpAsterisk] GetContactsFail';

  constructor(public error: UnknownError) {
  }
}


// added by plop
export class GetFavoriteContacts {
  static type = '[gpAsterisk] GetFavoriteContacts';

  constructor() {
  }
}


export class GetFavoriteContactsSuccess {
  static type = '[gpAsterisk] GetFavoriteContactsSuccess';

  constructor(public contacts: ContactModel[]) {
  }
}


export class GetFavoriteContactsFail {
  static type = '[gpAsterisk] GetFavoriteContactsFail';

  constructor(public error: UnknownError) {
  }
}


// added by plop
export class GetCallLogs {
  static type = '[gpAsterisk] GetCallLogs';

  constructor(public lazy = false, public filter?: PaginateQuery<{search: string}>) {
  }
}


export class GetCallLogsSuccess {
  static type = '[gpAsterisk] GetCallLogsSuccess';

  constructor(public callLogs: PaginatorModel<CallLogModel>, public lazy: boolean) {
  }
}


export class GetCallLogsFail {
  static type = '[gpAsterisk] GetCallLogsFail';

  constructor(public error: UnknownError) {
  }
}

export class SetFavoriteContact {
  static type = '[gpAsterisk] SetFavoriteContact';

  constructor(public contactId: string, public isFavorite: boolean) {
  }
}

export class DongleStatus {
  static type = '[Asterisk] DongleStatus';

  constructor(public payload: {device: string, status: DongleStatusEnum}) {
  }
}

export class CreateContact {
  static type = '[gpAsterisk] CreateContact';

  constructor(public contact: ContactModel) {
  }
}

export class UpdateContact {
  static type = '[gpAsterisk] UpdateContact';

  constructor(public contact: ContactModel) {
  }
}

export class DeleteContact {
  static type = '[gpAsterisk] DeleteContact';

  constructor(public id: string) {
  }
}

export class UpdateContactSuccess {
  static type = '[gpAsterisk] UpdateContactSuccess';
}

export class UpdateContactFail {
  static type = '[gpAsterisk] UpdateContactFail';

  constructor(public error: UnknownError) {
  }
}

